export default __webpack_public_path__ + "_/_/node_modules/ui-header/src/images/lc-logo-58e06378c932deb69afcd34ee1adc4d3.png";